module.exports = __webpack_public_path__ + "work_team.27e5b4f35eb74eabef308d22a7c19917.hashedasset.svg";